import axios from "axios"
import { zapiszPdf, zapiszOdpowiedz } from "../utils/pobierzPlik";
import {LocationInterface, PatchCustomerPoiInterface} from "../redux/vehicles/vehicles.type";
import {setQuery} from "../utils/utils";


async function getVehiclesApi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles`
    })
}

async function getLocationApi(data: LocationInterface) {
    function query() {
        const {vehicle_id, start_date, end_date} = data;
        if (!data.vehicle_id && !data.start_date && !data.end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/db-received-data-search${query()}`,
    })
}

async function getVehicleDetailsApi(workspaceUuid: string, vehicle_id: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles/${vehicle_id}`
    })
}

async function getPinDetailsApi(id: string) {
    return axios({
        method: "GET",
        url: `/api/v1/db-received-data/${id}`
    })
}

async function getVehicleLocationDetailsApi(workspaceUuid: string, vehicle_id: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-locations/${vehicle_id}`
    })
}

async function getVehiclesLocationsApi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-locations`
    });
}

async function getUserPoi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-pois`
    })
}

async function getVehiclesSearch(workspaceUuid: string, query: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicle-search${setQuery({query: query})}`
    })
}

async function getVehicleStartStop(data: any) {
    function query() {
        const {vehicle_id, start_date, end_date, parking_time} = data;
        if (!data.vehicle_id && !data.start_date && !data.end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        if (parking_time) query = query + "var=" + parking_time + "&";
        else query = query + "var=300&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/start-stop${query()}`
    })
}

async function getVehiclesNewStartStop(data: any) {
    function query() {
        const {vehicle_id, start_date, end_date, parking_time} = data;
        if (!data.vehicle_id && !data.start_date && !data.end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        if (parking_time) query = query + "var=" + parking_time + "&";
        else query = query + "var=300&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/new-start-stop${query()}`
    })
}

async function getCustomerPoi(uuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${uuid}/pois`
    })
}

async function getCustomerPoiDetails(item: any) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${item.uuid}/pois/${item.id}`
    })
}

async function patchCustomerPoi(uuid: string, poiUuid: string, data: PatchCustomerPoiInterface) {
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${uuid}/pois/${poiUuid}`,
        data
    })
}

async function postCustomerPoi(uuid: string, data: PatchCustomerPoiInterface) {
    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${uuid}/pois`,
        data
    })
}

async function deleteCustomerPoi(uuid: string, poiUuid: string) {
    return axios({
        method: "DELETE",
        url: `/api/v1/workspaces/${uuid}/pois/${poiUuid}`,
    })
}

async function getVehicleRpmApi(data: any) {
    const {vehicle_id, start_date, end_date} = data;
    return axios({
        method: "GET",
        url: `/api/v1/chart-rpm-vehicle/${vehicle_id}${setQuery({start_date}, {end_date})}`
    })
}

async function getVehiclesConfigurationApi(uuid: string,) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${uuid}/configuration-vehicles`
    })
}

async function getVehicleGeoAddress(item: any) {
    return axios({
        method: "GET",
        url: `/api/v1/geo-codes?latitude=${item.latitude}&longitude=${item.longitude}`
    })
}

async function getVehicleGroupsApi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-groups`
    })
}

async function getVehicleGroupDetailsApi(workspaceUuid: string, groupId: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-groups/${groupId}`
    })
}

async function getVehiclesFromGroupApi(workspaceUuid: string, groupId: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-groups/${groupId}/vehicles`
    })
}

async function getFuelTankVehicleApi(data: {vehicle_id: string, start_date: any, end_date: any}){
    const {vehicle_id, start_date, end_date} = data;
    return axios({
        method: "GET",
        url: `/api/v1/fuel-tank-vehicle/${vehicle_id}${setQuery({start_date}, {end_date})}`
    })
}

async function getFuelTankVehicleCombinedApi(data: any){
    const {vehicle_id, start_date, end_date} = data;
    return axios({
        method: "GET",
        url: `/api/v1/fuel-tank-sum-vehicle/${vehicle_id}${setQuery({start_date}, {end_date})}`
    })
}

async function getVehiclesUngroupedApi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-ungroups`
    })
}

async function getVehiclesWithConfigurationApi(workspaceUuid: string) {
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-vehicles-with-configs`
    })
}

async function getVehicleExceedingRpmLimitsExport(
    vehicle_id: string,
    start_date: string,
    end_date: string,
    type: string = "csv",
    title: string = "doc"
) {
    function query() {
        if (!vehicle_id && !start_date && !end_date) return "";
        let query = "?";
        if (type) query = query + "type=" + type + "&";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/exceeding-rpm-limits/export${query()}`,
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${title}.${type}`); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

async function getVehicleNewStartStopExportCsv(
    vehicle_id: string,
    parking_time: string,
    start_date: string,
    end_date: string,
    title: string = "doc",
    map_image: string = ""
) {
    function query() {
        if (!vehicle_id && !start_date && !end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        if (parking_time) query = query + "var=" + parking_time + "&";
        else query = query + "var=300&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/new-start-stop-exportcsv${query()}`,
        responseType: 'blob', // important
        data: {
            map_image
        }
    }).then(zapiszOdpowiedz);
}

async function getVehicleNewStartStopExportPdf(
    vehicle_id: string,
    start_date: string,
    end_date: string,
    title: string = "doc",
    map_image: string = ""
) {
    function query() {
        if (!vehicle_id && !start_date && !end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "POST",
        url: `/api/v1/new-start-stop-pdf${query()}`,
        responseType: 'blob', // important
        data: {
            map_image
        }
    }).then((response) => {
        /*
         * Sprawdzamy, czy to naprawde PDF — nie zapisujemy w ciemno.
         *
         * POTWIERDZONE 2026-09-16 NA TYM ENDPOINCIE: odpowiedz miala kod 200
         * i 77 bajtow tresci "TCPDF ERROR: Could not include font definition
         * file: segoeui". Plik zapisal sie jako
         * "RENAULT PREMIUM WGM68331 ....pdf", a czytnik pokazal "Nie udalo
         * sie wczytac dokumentu PDF" — komunikat bez zwiazku z przyczyna.
         *
         * To DRUGI z czterech endpointow PDF z tym samym bledem (pierwszy:
         * telemetria). Dwa niezalezne raporty, identyczna tresc bledu —
         * wskazuje to na wspolna konfiguracje czcionki w TCPDF, a nie na
         * usterke pojedynczego raportu.
         */
        return zapiszPdf(response.data, `${title}.pdf`);
    });
}

async function getVehicleNewStartStopExportExcel(
    vehicle_id: string,
    parking_time: any,
    start_date: string,
    end_date: string
) {
    function query() {
        if (!vehicle_id && !start_date && !end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (parking_time) query = query + "var=" + parking_time + "&";
        else query = query + "var=300&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/new-start-stop-excel${query()}`,
        responseType: 'blob', // important
    }).then(zapiszOdpowiedz);
}

async function getVehicleDisturbanceApi(data: any){
    const {vehicle_id, start_date, end_date, type} = data;
    return axios({
        method:"GET",
        url: `/api/v1/fuel-disturbance-vehicle/${vehicle_id}${setQuery({start_date}, {end_date}, {type})}`
    })
}

async function getTelemetryPdfApi(uuid: string, choice: string | null, map_image: string = "", title: string = "doc") {
    const data = {
        choice,
        map_image
    };
    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${uuid}/db-vehicles-locations-pdf`,
        responseType: 'blob', // important
        data
    }).then((response) => {
        /*
         * Nie zapisujemy tego, co przyszlo, w ciemno.
         *
         * 2026-09-16: ten endpoint odpowiedzial kodem 200 i trescia
         * "TCPDF ERROR: Could not include font definition file: segoeui" —
         * 77 bajtow HTML-a. Stary kod zapisal to jako .pdf, a uzytkownik
         * zobaczyl w czytniku "Nie udalo sie wczytac dokumentu PDF", bez
         * zadnego sladu prawdziwej przyczyny. Przy responseType "blob"
         * axios nie rzuca wyjatkiem, bo status jest poprawny.
         *
         * `zapiszPdf` odrzuca obietnice trescia bledu z serwera, dzieki
         * czemu wywolujacy pokazuje uzytkownikowi to, co naprawde sie stalo.
         * Zwalnia tez adres blob i usuwa dopisany odnosnik — czego zadne
         * z 15 miejsc pobierania plikow w tym repozytorium nie robilo.
         */
        return zapiszPdf(response.data, `${title}.pdf`);
    });
}

async function getVehicleIgnitionOnSpeedCsv(vehicleId: string, start_date: string, end_date: string) {
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/ignition-speed-report/${vehicleId}/export-csv${query()}`,
        responseType: 'blob', // important
    }).then(zapiszOdpowiedz);
}

async function getVehicleIgnitionOnSpeedSpeed(vehicleId: string, start_date: string, end_date: string) {
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/ignition-speed-report/${vehicleId}/export-excel${query()}`,
        responseType: 'blob', // important
    }).then(zapiszOdpowiedz);
}

async function getVehicleIgnitionOnRpmCsv(vehicleId: string, start_date: string, end_date: string) {
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/ignition-rpm-report/${vehicleId}/export-csv${query()}`,
        responseType: 'blob', // important
    }).then(zapiszOdpowiedz);
}

async function getVehicleIgnitionOnRpmExcel(vehicleId: string, start_date: string, end_date: string) {
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/ignition-rpm-report/${vehicleId}/export-excel${query()}`,
        responseType: 'blob', // important
    }).then(zapiszOdpowiedz);
}

async function getRouteReportApi(uuid: string, first_chart: string | null = null, second_chart: string | null = null, first_choice: string, second_choice: string, query: any, title: string = "doc", fuel_chart_1: string | null = null, fuel_chart_2: string | null = null, fuel_chart_3: string | null = null, fuel_chart_4: string | null = null, fuel_chart_5: string | null = null, fuel_chart_6: string | null = null, fuel_chart_7: string | null = null, fuel_chart_8: string | null = null,) {
    const {start_date, end_date, vehicle_id} = query;

    function setQuery() {
        if (!vehicle_id && !start_date && !end_date) return "";
        let query = "?";
        if (vehicle_id) query = query + "vehicle_id=" + vehicle_id + "&";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${uuid}/route-report-to-pdf${setQuery()}`,
        responseType: 'blob', // important
        data: {
            first_chart,
            second_chart,
            first_choice,
            second_choice,
            fuel_chart_1,
            fuel_chart_2,
            fuel_chart_3,
            fuel_chart_4,
            fuel_chart_5,
            fuel_chart_6,
            fuel_chart_7,
            fuel_chart_8,
        }
    }).then((response) => {
        /*
         * Sprawdzamy, czy to naprawde PDF — nie zapisujemy w ciemno.
         *
         * Tego konkretnego endpointu NIE sprawdzilam. Ochrona jest tu
         * profilaktyczna: dwa inne endpointy PDF (telemetria i
         * new-start-stop) odpowiadaja kodem 200 i trescia bledu TCPDF
         * zamiast pliku, wiec kod 200 przestal byc dowodem powodzenia
         * gdziekolwiek w tej aplikacji.
         */
        return zapiszPdf(response.data, `${title}.pdf`);
    });
    /*
     * BYL TU `.catch(() => {})` — pusty, wiec polykal blad w calosci.
     * Skutek: przy PDF-ie raportu trasy nie pojawial sie ZADEN komunikat.
     * `zapiszPdf` wykrywal, ze serwer oddal tresc bledu zamiast dokumentu,
     * odrzucal obietnice z ta trescia — i ten pusty `catch` ja wyrzucal,
     * zanim ktokolwiek mogl ja pokazac. Nie polykamy juz: blad idzie do
     * sagi, a ta nazywa go uzytkownikowi.
     */
}

async function getBottomOfTopBarApi(data: any) {
    const { vehicle_id, start_date, end_date } = data;
    return axios({
        method: "GET",
        url: `/api/v1/top-bar/${vehicle_id}${setQuery({start_date}, {end_date})}`
    })
}

export {
    getVehiclesApi,
    getLocationApi,
    getVehicleDetailsApi,
    getPinDetailsApi,
    getVehiclesLocationsApi,
    getVehicleLocationDetailsApi,
    getVehiclesSearch,
    getUserPoi,
    getVehicleStartStop,
    getCustomerPoi,
    getCustomerPoiDetails,
    patchCustomerPoi,
    postCustomerPoi,
    deleteCustomerPoi,
    getVehiclesConfigurationApi,
    getVehicleRpmApi,
    getVehicleGeoAddress,
    getVehicleGroupsApi,
    getVehicleGroupDetailsApi,
    getVehiclesFromGroupApi,
    getVehiclesUngroupedApi,
    getVehiclesNewStartStop,
    getVehiclesWithConfigurationApi,
    getVehicleNewStartStopExportCsv,
    getVehicleNewStartStopExportExcel,
    getVehicleIgnitionOnSpeedCsv,
    getVehicleIgnitionOnSpeedSpeed,
    getVehicleIgnitionOnRpmCsv,
    getVehicleIgnitionOnRpmExcel,
    getVehicleNewStartStopExportPdf,
    getTelemetryPdfApi,
    getRouteReportApi,
    getFuelTankVehicleApi,
    getVehicleExceedingRpmLimitsExport,
    getFuelTankVehicleCombinedApi,
    getVehicleDisturbanceApi,
    getBottomOfTopBarApi,

}